export default __webpack_public_path__ + "static/media/united_bag_sample.d17f56e0.csv";